import axios from '@/utils/axios'
// 组件列表
export function listAd(query) {
    return axios({
        url: '/video/clientUnlockConfigure/list',
        method: 'get',
        params: query
    })
}
export function details(query) {
    return axios({
        url: '/video/clientUnlockConfigure/getUnlockConfigInfo',
        method: 'get',
        params: query
    })
}
// 添加
export function addAd(query) {
    return axios({
        url: '/video/clientUnlockConfigure/addOrEditUnlockConfig/save',
        method: 'post',
        data: query
    })
}
// 删除
export function delAd(query) {
    return axios({
        url: '/video/clientUnlockConfigure/delUnlockConfig/save',
        method: 'post',
        params: query
    })
}
// 广告解锁弹框列表
export function videoUnlockList(query) {
    return axios({
        url: '/video/clientUnlockConfigure/videoUnlockList',
        method: 'get',
        params: query
    })
}
// 获取播放状态
export function getAdStatus(query) {
    return axios({
        url: '/video/clientUnlockConfigure/getAdStatus',
        method: 'get',
        params: query
    })
}
// 设置播放状态
export function setAdStatus(query) {
    return axios({
        url: '/video/clientUnlockConfigure/updateAdStatus',
        method: 'get',
        params: query
    })
}